module.exports = __webpack_public_path__ + "images/traffic_light_pass_baked.f81c1f3b79d07718d9df8a171a258531.png";